import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/utils';
import intlTelInput from 'intl-tel-input';

import Component from '../../component/component';

import './textfield.scss';

export default class Textfield extends Component {
    static initSelector: string = '.js-textfield';

    public input: JQuery;
    public initialCountry: string;

    constructor(target: HTMLElement) {
        super(target);

        this.input = this.element.find('.textfield__input');
        this.initialCountry = this.input.attr('data-initial-country');

        this.init();
    }

    init(): void {
        intlTelInput(this.input[0], {
            autoPlaceholder: 'off',
            hiddenInput: this.input.attr('name') + '_full',
            initialCountry: this.initialCountry,
            separateDialCode: true,
        });

        this.handleRightPadding();
        this.input[0].addEventListener('countrychange', this.handleRightPadding.bind(this));
    }

    handleRightPadding(): void {
        const leftPadding: string = this.input.css('padding-left');

        this.input.css('padding-right', leftPadding);
    }
}
